import { SecurityIssues } from '@models';

export interface SecurityIssuesResult {
  rootSecurityIssues: SecurityIssues[];
}
